{
  "login-secret-with-pin-page": {
    "buttons": {
      "resend": "Gửi lại",
      "submit": "Xác nhận"
    },
    "text": {
      "in-second": "sau {{seconds}} giây",
      "pin-email-invalid": "Mã PIN không chính xác. Vui lòng kiểm tra trong Email của bạn và thử lại.",
      "pin-sms-invalid": "Mã PIN không chính xác. Vui lòng kiểm tra trong tin nhắn của bạn và thử lại.",
      "resend-pin-hint": "Bạn không nhận được bất kỳ mã PIN nào?",
      "verify-email": "Xác minh email của bạn",
      "verify-phone-nr": "Xác minh số điện thoại của bạn",
      "verify-update": "Xác minh cập nhật của bạn",
      "verify-update-by-email": "Bạn sẽ nhận được mã pin xác nhận qua Email",
      "verify-update-by-sms": "Bạn sẽ nhận được mã pin xác nhận qua SMS"
    }
  }
}
